import createApp from "../App";

createApp();
